'use client';

import { c as _c } from "react/compiler-runtime";
import type { CodeSessionEvent } from '@/lib/code-sessions/types';
import { useEffect, useEffectEvent, useSyncExternalStore } from 'react';
import type { SessionConnection, SessionFeedProps } from '../types';
import { localAgentConnection } from './connection';
import { localSessionFeed } from './local-events';
import { startAgainFirst } from './local-retry';

/** The page's one stream to this computer. Its first read builds the page's connection there. */
const localStream = {
  watch: (onChange: () => void) => localAgentConnection()?.watchStream(onChange) ?? (() => {}),
  state: (): SessionConnection => localAgentConnection()?.streamState() ?? 'live',
  serverState: (): SessionConnection => 'live'
};
export function LocalSessionFeed(t0) {
  const $ = _c(20);
  const {
    sessionId,
    controller,
    receive,
    dropHeld
  } = t0;
  let t1;
  if ($[0] !== receive) {
    t1 = events => receive(events);
    $[0] = receive;
    $[1] = t1;
  } else {
    t1 = $[1];
  }
  const receiveLocal = useEffectEvent(t1);
  let t2;
  if ($[2] !== dropHeld) {
    t2 = () => dropHeld();
    $[2] = dropHeld;
    $[3] = t2;
  } else {
    t2 = $[3];
  }
  const drop = useEffectEvent(t2);
  let t3;
  if ($[4] !== controller || $[5] !== drop || $[6] !== receiveLocal || $[7] !== sessionId) {
    t3 = () => {
      const feed = localSessionFeed(sessionId);
      feed.attach(controller);
      return feed.subscribe(receiveLocal, drop);
    };
    $[4] = controller;
    $[5] = drop;
    $[6] = receiveLocal;
    $[7] = sessionId;
    $[8] = t3;
  } else {
    t3 = $[8];
  }
  let t4;
  if ($[9] !== controller || $[10] !== sessionId) {
    t4 = [controller, sessionId];
    $[9] = controller;
    $[10] = sessionId;
    $[11] = t4;
  } else {
    t4 = $[11];
  }
  useEffect(t3, t4);
  const connection = useSyncExternalStore(localStream.watch, localStream.state, localStream.serverState);
  let t5;
  if ($[12] !== controller || $[13] !== sessionId) {
    t5 = () => startAgainFirst(sessionId, () => controller.refresh({
      cancelRefetch: true
    }));
    $[12] = controller;
    $[13] = sessionId;
    $[14] = t5;
  } else {
    t5 = $[14];
  }
  const retry = t5;
  let t6;
  let t7;
  if ($[15] !== connection || $[16] !== controller || $[17] !== retry) {
    t6 = () => {
      controller.reportConnection(connection, retry);
    };
    t7 = [connection, controller, retry];
    $[15] = connection;
    $[16] = controller;
    $[17] = retry;
    $[18] = t6;
    $[19] = t7;
  } else {
    t6 = $[18];
    t7 = $[19];
  }
  useEffect(t6, t7);
  return null;
}